import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useTankMonitors = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useTankMonitorOverviewQuery = (filter) =>
    useQuery({
      queryKey: ['tankMonitorOverviewQuery', filter],
      queryFn: ({ queryKey }) =>
        api.post('ims/overview', {
          filter: { ...queryKey[1] },
        }),
    })

  return { useTankMonitorOverviewQuery }
}
